import React from 'react'
import GenericTabs from '../../components/Tabs'
import { studentsAndFacultyTabs } from '../../consts/studentsAndFacultyTabs'
import Students from '../../features/Students'
import PageHeader from '../../components/PageHeader'
import PAGE_TITLES from '../../consts/titles'
import CustomHeader from '../../components/CustomHeader'
import { Box } from '@mui/material'

const Page = (): JSX.Element => {
  return (
    <Box display='flex' flexDirection='column' gap={6}>
      <CustomHeader title={PAGE_TITLES.USERS} />
      <PageHeader title={PAGE_TITLES.USERS} />
      <GenericTabs tabs={studentsAndFacultyTabs} />
      <Students />
    </Box>
  )
}

export default Page
